module.exports = __webpack_public_path__ + "static/media/tap-01.cce05077.png";